import { Color } from 'zens-storybook'
import React from 'react'
import { StyleSheet, View, ViewProps } from 'react-native'

const styles = StyleSheet.create({
  container: {
    width: 6,
    height: 20,
    backgroundColor: Color.premiumBlack,
    borderRadius: 3,
    alignItems: 'center',
    justifyContent: 'center',
  },
  inner: {
    width: 2,
    height: 10,
    backgroundColor: Color.simplyWhite,
    borderRadius: 1,
  },
})

interface Props extends ViewProps {}
const Thumb = (props: Props) => {
  const { style, ...otherProps } = props
  return (
    <View style={[styles.container, style]} {...otherProps}>
      <View style={styles.inner} />
    </View>
  )
}

export default Thumb
